import React, { FC } from 'react';
import { Button, ButtonProps } from '@material-ui/core';
import { useHistory } from 'react-router';

import { useStyles } from './styles';

export interface NavButtonProps extends ButtonProps {
  label: string;
  target: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  size?: 'medium' | 'large' | 'small' | undefined;
  isCurrent?: boolean;
}

const NavButton: FC<NavButtonProps> = ({
  label,
  target,
  onClick,
  size,
  isCurrent = false,
  className,
  ...otherProps
}) => {
  const classes = useStyles({ isCurrent });
  const { push } = useHistory();


  return (
    <a
      href={target}
      className={` w-full text-center primary_font text-white px-3 tracking-wider py-2`}
    >
      <p>{label}</p>
    </a>
  );
};

export default NavButton;
